
//
// QR Size Adjuster
//
//

module.exports = function QRSizeAdjuster ($host, config) {

  // Dom
  var dom = {
    main:  $host,
    input: $('[data-size-input]', $host),
    code:  $('[data-code-template]', $host)
  };

  var template = dom.code.text();


  // Functions

  function updateCode () {
    dom.code.text(fillTemplate(template, { size: dom.input.val() }));
  }

  // Listeners
  dom.input.on('change blur keyup paste', updateCode);

  // Init
  updateCode();

};

